// Builds a display name for a guest, falling back to a placeholder when
// firstName/lastName are both null/empty so list rows always have clickable
// link text (an empty string renders an invisible, unclickable link).
export default function getGuestDisplayName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = "(No Name)",
): string {
  const name = [firstName, lastName]
    .filter((part) => !!part && part.trim().length > 0)
    .join(" ");
  return name || fallback;
}
